import React, { useState } from 'react';
import CrewSelect from 'components/CrewSelect';
import _ from 'underscore';
import styled from 'styled-components';
import StyledNavLink from 'components/nav/Link';
import StyledNavTabs from 'components/nav/Tabs';

import {
  TabContent,
  TabPane,
  NavItem,
  Input,
  Label,
  Form,
  FormGroup,
} from 'reactstrap';

import { Button } from '@shoflo/polymer/components/Button/Button';
import Roles from 'constants/Roles';

const humanize = require('underscore.string/humanize');

const StyledLabel = styled(Label)`
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  color: #333;
`;

const StyledSelect = styled(Input)`
  display: inline-block;
  width: auto;
  margin-left: 7px;
`;

const InviteCrew = ({
  crewAutoCompleteOptions,
  selectedUsers,
  onSubmit,
  onCancel,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(selectedUsers || []);
  const [selectedRole, setRole] = useState(Roles.ReadOnly);

  const roleOptionNodes = _.map(Roles, (value, name) => {
    return (
      <option key={`invite-role-picker-${value}`} value={value}>
        {humanize(name)}
      </option>
    );
  });

  return (
    <>
      <StyledNavTabs tabs>
        <NavItem>
          <StyledNavLink active={true}>Invite via email</StyledNavLink>
        </NavItem>
      </StyledNavTabs>

      <TabContent activeTab={1}>
        <TabPane tabId={1}>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              setIsSubmitting(true);
              onSubmit(selectedOptions, selectedRole);
            }}
          >
            <p>
              Give the following people the permission of:
              <StyledSelect
                data-testid="permissionSelect"
                value={selectedRole}
                onChange={(e) => setRole(e.target.value)}
                type="select"
              >
                {roleOptionNodes}
              </StyledSelect>
            </p>

            <FormGroup data-testid="crewSelectComponent">
              <StyledLabel data-testid="crewSelectTitle">
                Email
              </StyledLabel>
              <CrewSelect
                selectedOptions={selectedOptions}
                options={crewAutoCompleteOptions}
                onChange={setSelectedOptions}
              />
            </FormGroup>

            <div className="float-end">
              <Button
                data-testid="createButton"
                color="primary"
                disabled={
                  isSubmitting || !selectedOptions || !selectedOptions.length
                }
              >
                Send
              </Button>{' '}
              {onCancel && (
                <Button
                  data-testid="cancelButton"
                  type="button"
                  onClick={onCancel}
                  color="secondary"
                  variant="outlined"
                >
                  Cancel
                </Button>
              )}
            </div>
          </Form>
        </TabPane>
      </TabContent>
    </>
  );
};

InviteCrew.defaultProps = {
  crewAutoCompleteOptions: [],
};

export default InviteCrew;
